<template>
	<div class="main">
		<div class="naverwebtoon">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<a href=""><img src="../assets/image/naverwebtoon_bigbanner.png" alt=""></a>
		</div>
		<div class="box">
			<Header ref="header"></Header>
			<!-- <GameBanner :src="gameData.topBgImage" :variant="activity"></GameBanner> -->
			<GameBanner :src="gameData.topBgImage" :variant="gameData.extraFields.bannerType"
				:drawProductId="gameData.extraFields.bannerDrawProductId" />
			<div class="item_Options">
				<div class="content recharge-layout">
					<aside class="recharge-sidebar">
						<UserInfo ref="userInfo" class="sidebar-user" :show-vip-card="true"></UserInfo>
						<RebateCountdown v-if="rebate.mode == 3 && rebate.leftSeconds > 0" :rebate="rebate"
							class="sidebar-countdown" />
						<!-- <RebateCouponLotteryCard
							v-if="isRebateCouponLotteryEnabled"
							v-show="hasLogin && hasOpenCouponPopup"
							:lottery-count="lotteryCount"
							@open-rules="openCouponLotteryRules"
							@open-lottery="openActivityPopup"
						/> -->
					</aside>
					<div class="recharge-main">
						<SuperCoupon v-if="isSuperCouponEnabled()" :game-code="gameData.gameCode"
							@buy="openLimitedCouponOrder" @details="lookGoodsDetails" />
					<section class="position recharge-panel">
						<div class="product-tabs" v-if="hasQuota || hasInGame || hasOther">
							<div ref="tabContainer" class="tab-container" @scroll.passive="updateTabScrollState">
								<button @click="changeGoodsTypeEvent('direct')"
									:class="['tab-item', currClassify == 'direct' ? 'active' : '']">
									{{ $t('hot_title_text') }}
								</button>
								<button v-if="hasQuota" @click="changeGoodsTypeEvent('quota')"
									:class="['tab-item', currClassify == 'quota' ? 'active' : '']">
									{{ gameData.gameCode == 'sgyjltw' ? '官網限定禮包' : (gameData.gameCode == 'cztxkr' ?
										'한정구매' : $t('limit_title_text')) }}
								</button>
								<button v-if="hasOther" @click="changeGoodsTypeEvent('other')"
									:class="['tab-item', currClassify == 'other' ? 'active' : '']">
									{{ $t('other_title_text') }}
								</button>
								<button v-if="hasInGame" @click="changeGoodsTypeEvent('ingame')"
									:class="['tab-item', currClassify == 'ingame' ? 'active' : '']">
									MyCard
								</button>

								<button v-if="showBankTransfer()" @click="changeGoodsTypeEvent('transfer')"
									:class="['tab-item', currClassify == 'transfer' ? 'active' : '']">
									銀行匯款
								</button>
							</div>
							<span v-if="tabsScrollable && !tabsScrollAtEnd" class="tab-scroll-hint" aria-hidden="true">
								<i class="fa fa-chevron-right"></i>
							</span>
						</div>
						<!-- 返利券展示区 -->
						<CouponBanner ref="couponBanner" v-if="hasLogin && openCouponPopup()"
							@select="onCouponSelect" />
						<!-- 限购商品购买 -->
						<ul v-show="currClassify == 'quota'" class="goods-list">
							<li v-for="goods in quotaGoodsList" :key="goods.productId" class="goods-card"
								v-analytics-exposure="productExposure(goods, 'quota')"
								:class="goods.quotaNum == 0 ? 'disable' : ''">
								<div class="store" v-if="hasRebate(goods)">
									<img :src="rebate.icon" alt="">
									<span>{{ getRebateNum(goods) }}%</span>
								</div>
								<p class="goods_index color">
									{{ $t('limit_text') }}:{{ goods.quotaNum }}/{{ goods.limitNum }}
								</p>
								<img class="recharge" :src="goods.icon" alt="">
								<p>{{ goods.tips }} <i v-show="!!goods.describe" v-on:click="lookGoodsDetails(goods)"
										class="fa fa-exclamation-circle"></i></p>
								<div v-if="(goods.vipExp && goods.vipExp > 0) || (goods.points && goods.points > 0)"
									class="goods-bonus-bar">
									<div v-if="goods.vipExp && goods.vipExp > 0" class="goods-bonus-item goods-bonus-item--exp">
										<img src="/static/image/vip_exp.png" alt="" aria-hidden="true">
										<strong>+{{ goods.vipExp }}</strong>
									</div>
									<div v-if="goods.points && goods.points > 0" class="goods-bonus-item goods-bonus-item--points">
										<img src="/static/image/points_new.png" alt="" aria-hidden="true">
										<strong>+{{ goods.points }}</strong>
									</div>
								</div>
								<button v-if="goods.quotaNum > 0" :class="['price', 'bg_color']"
									v-on:click="openConfirmOrderWindow(goods.productId)">{{
										goods.buttonText }}</button>
								<button v-if="goods.quotaNum == 0" :class="['price', 'describe_button']"
									disabled="true">{{ $t('sell_out_text') }}</button>
							</li>
						</ul>
						<!-- 直购商品购买 -->
						<ul v-show="currClassify == 'direct'" class="goods-list">
							<li v-for="goods in directGoodsList" :key="goods.productId" class="goods-card"
								v-analytics-exposure="productExposure(goods, 'direct')">
								<div class="store" v-if="hasRebate(goods)">
									<img :src="rebate.icon" alt="">
									<span>{{ getRebateNum(goods) }}%</span>
								</div>
								<img class="recharge" :src="goods.icon" alt="">
								<p>{{ goods.tips }} <i v-show="!!goods.describe" v-on:click="lookGoodsDetails(goods)"
										class="fa fa-exclamation-circle"></i></p>
								<div v-if="(goods.vipExp && goods.vipExp > 0) || (goods.points && goods.points > 0)"
									class="goods-bonus-bar">
									<div v-if="goods.vipExp && goods.vipExp > 0" class="goods-bonus-item goods-bonus-item--exp">
										<img src="/static/image/vip_exp.png" alt="" aria-hidden="true">
										<strong>+{{ goods.vipExp }}</strong>
									</div>
									<div v-if="goods.points && goods.points > 0" class="goods-bonus-item goods-bonus-item--points">
										<img src="/static/image/points_new.png" alt="" aria-hidden="true">
										<strong>+{{ goods.points }}</strong>
									</div>
								</div>
								<button :class="['price', 'bg_color']"
									v-on:click="openConfirmOrderWindow(goods.productId)">{{
										goods.buttonText }}</button>
							</li>
						</ul>
						<!-- 點卡商品购买 -->
						<ul v-show="currClassify == 'ingame'" class="goods-list">
							<li v-for="goods in inGameGoodsList" :key="goods.productId" class="goods-card"
								v-analytics-exposure="productExposure(goods, 'ingame')">
								<div class="store" v-if="hasRebate(goods)">
									<img :src="rebate.icon" alt="">
									<span>{{ getRebateNum(goods) }}%</span>
								</div>
								<img class="recharge" :src="goods.icon" alt="">
								<p>{{ goods.tips }} <i v-show="!!goods.describe" v-on:click="lookGoodsDetails(goods)"
										class="fa fa-exclamation-circle"></i></p>
								<div v-if="(goods.vipExp && goods.vipExp > 0) || (goods.points && goods.points > 0)"
									class="goods-bonus-bar">
									<div v-if="goods.vipExp && goods.vipExp > 0" class="goods-bonus-item goods-bonus-item--exp">
										<img src="/static/image/vip_exp.png" alt="" aria-hidden="true">
										<strong>+{{ goods.vipExp }}</strong>
									</div>
									<div v-if="goods.points && goods.points > 0" class="goods-bonus-item goods-bonus-item--points">
										<img src="/static/image/points_new.png" alt="" aria-hidden="true">
										<strong>+{{ goods.points }}</strong>
									</div>
								</div>
								<button :class="['price', 'bg_color']"
									v-on:click="openConfirmOrderWindow(goods.productId)">{{
										goods.buttonText }}</button>
							</li>
						</ul>
						<!-- 點卡商品购买 -->
						<ul v-show="currClassify == 'other'" class="goods-list">
							<li v-for="goods in otherGoodsList" :key="goods.productId" class="goods-card"
								v-analytics-exposure="productExposure(goods, 'other')">
								<div class="store" v-if="hasRebate(goods)">
									<img :src="rebate.icon" alt="">
									<span>{{ getRebateNum(goods) }}%</span>
								</div>
								<img class="recharge" :src="goods.icon" alt="">
								<p>{{ goods.tips }} <i v-show="!!goods.describe" v-on:click="lookGoodsDetails(goods)"
										class="fa fa-exclamation-circle"></i></p>
								<div v-if="(goods.vipExp && goods.vipExp > 0) || (goods.points && goods.points > 0)"
									class="goods-bonus-bar">
									<div v-if="goods.vipExp && goods.vipExp > 0" class="goods-bonus-item goods-bonus-item--exp">
										<img src="/static/image/vip_exp.png" alt="" aria-hidden="true">
										<strong>+{{ goods.vipExp }}</strong>
									</div>
									<div v-if="goods.points && goods.points > 0" class="goods-bonus-item goods-bonus-item--points">
										<img src="/static/image/points_new.png" alt="" aria-hidden="true">
										<strong>+{{ goods.points }}</strong>
									</div>
								</div>
								<button :class="['price', 'bg_color']"
									v-on:click="openConfirmOrderWindow(goods.productId)">{{
										goods.buttonText }}</button>
							</li>
						</ul>
						<div class="transfer" style="margin-left: 0px;"
							v-show="currClassify == 'transfer' && showBankTransfer()">
							<!-- <img
								src="https://cdn-download.dustyx.com/image/cms/20250818/a84e5b4308ac435dad247968e57c9b02.png"> -->
							<component :is="bankRemitComponent" v-if="bankRemitComponent"></component>
						</div>
						<p class="h3">{{ $t('recharge_instructions_text') }}</p>
						<p class="instructions" v-html="gameData.describe"></p>
						<div>
							<a class="color" :href="gameData.facebookFanPage">[{{ gameData.gameName }}]
								{{ $t('official_facebook_text') }}
								>></a><br>
							<a class="color" :href="gameData.apkLink">[{{ gameData.gameName }}]
								{{ $t('official_apk_download_text') }}
								>></a><br>
						</div>
					</section>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>

		<!-- 返利券悬浮活动入口 -->
		<button v-show="hasLogin && hasOpenCouponPopup" class="activity-btn-float bg_color" type="button"
			v-analytics-exposure="{ event: 'activity_exposure', key: 'rebate_coupon_lottery', properties: { activity_id: 'rebate_coupon_lottery', activity_name: '返利券抽奖', placement: 'floating_entry' } }"
			@click="openActivityPopup">
			<i class="fa fa-gift" aria-hidden="true"></i>
			<span>{{ $t('coupon.activity_button_text') }}</span>
		</button>

		<div id="details" class="details">
			<i class="fa fa-close bg_color b-close"></i>
			<p class="details-title">{{ lookGoods.tips }}</p>
			<img v-if="lookGoods.icon" :src="lookGoods.icon" alt="">
			<p class="details-text" v-html="!lookGoods.describe ? lookGoods.tips : lookGoods.describe"></p>
		</div>
		<component :is="dynamicComponent" v-if="hasLogin && dynamicComponent && showOrderWindow" :goods="goods"
			:rebate="rebate" @close="closeOrderWindow">
		</component>
		<!-- 活动弹窗 -->
		<CouponLottery v-if="isRebateCouponLotteryEnabled" :visible="showCouponLottery" @close="closeCouponLottery"
			@lottery-count-change="lotteryCount = $event" ref="CouponLottery" />
		<ActivityPopup v-model="showActivityPopup"></ActivityPopup>
		<!-- <MemberPointsPopup v-if="showMemberPointsPopup" @close="showMemberPointsPopup = false" /> -->
	</div>
</template>

<script>
import $ from 'jquery'
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import BankRemit from '../components/BankRemit.vue'
import CouponBanner from '../components/CouponBanner.vue'
import GameBanner from '../components/GameBanner.vue'
import SuperCoupon from '../components/common/SuperCoupon.vue'
import RebateCouponLotteryCard from '../components/common/RebateCouponLotteryCard.vue'
import RebateCountdown from '../components/RebateCountdown.vue'
import ActivityPopup from '../components/ActivityPopup.vue'
import CouponLottery from '../components/common/CouponLottery.vue'
import MemberPointsPopup from '../components/MemberPointsPopup.vue'
import axios from 'axios'
import {
	isEmpty,
	isNotEmpty,
	calculateRebatePercent,
	checkOldActivityEnabled
} from '../utils/index.js'
import tracker from '../utils/tracker.js'
import {
	getGoodsJsonUrl
} from '../utils/api'
export default {
	name: 'index',
	components: {
		Header,
		Footer,
		UserInfo,
		BankRemit,
		CouponBanner,
		GameBanner,
		SuperCoupon,
		RebateCouponLotteryCard,
		RebateCountdown,
		ActivityPopup,
		CouponLottery,
		MemberPointsPopup
	},
	data() {
		return {
			goods: {},
			goodsData: [],
			directGoodsList: [],
			quotaGoodsList: [],
			inGameGoodsList: [],
			otherGoodsList: [],
			rebate: {},
			lookGoods: {},
			hasQuota: false,
			hasInGame: false,
			hasOther: false,
			currClassify: 'direct',
			dynamicComponent: null,
			bankRemitComponent: null,
			gameData: this.$store.state.gameData,
			hasLogin: this.$session.hasLogin(),
			loginData: this.$cache.getLoginData(),
			purchasedProducts: '',
			showOrderWindow: false,
			selectedCoupon: null,
			showMemberPointsPopup: true,
			showActivityPopup: false,
			showCouponLottery: false,
			hasOpenCouponPopup: false,
			lotteryCount: 0,
			tabsScrollable: false,
			tabsScrollAtEnd: true
		}
	},
	mounted() {
		this.loadGoodsList();
		this.loadRebateData();
		this.loadComponent();
		if (this.hasLogin && this.isRebateCouponLotteryEnabled) this.openCouponPopup();
		// if(this.gameData.gameCode == 'cztxkr') {
		// 	this.loadPurchasedProducts();
		// }
		this.changeBackground(this.gameData.bottomBgImage);
		tracker.pageView();
		if (this.$route && this.$route.query && this.$route.query.showLogin) {
			if (this.$refs.header && this.$refs.header.openLoginWindow) {
				this.$refs.header.openLoginWindow();
			}
		}
		window.addEventListener('resize', this.handleTabsResize)
		this.$nextTick(() => this.updateTabScrollState())
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleTabsResize)
	},
	computed: {
		isRebateCouponLotteryEnabled() {
			// const extraFields = this.gameData && this.gameData.extraFields
			// return !!extraFields && extraFields.enableRebateCouponLottery === true
			return true;
		}
	},
	watch: {
		showActivityPopup(val, oldVal) {
			if (oldVal && !val) {
				// 弹窗关闭时，调用CouponBanner的loadCoupons方法
				if (this.$refs.couponBanner && this.$refs.couponBanner.loadCoupons) {
					this.$refs.couponBanner.loadCoupons();
				}
			}
		},
		showCouponLottery(val, oldVal) {
			if (oldVal && !val) {
				// 弹窗关闭时，调用CouponBanner的loadCoupons方法
				if (this.$refs.couponBanner && this.$refs.couponBanner.loadCoupons) {
					this.$refs.couponBanner.loadCoupons();
				}
			}
		},
		$route(to) {
			if (to && to.query && to.query.showLogin) {
				if (this.$refs.header && this.$refs.header.openLoginWindow) {
					this.$refs.header.openLoginWindow();
				}
			}
		}
	},
	methods: {
		productExposure(goods, category) {
			return { event: 'product_exposure', key: goods.productId, properties: { product_id: goods.productId, product_name: goods.productName || goods.name || goods.tips, product_category: category } }
		},
		handleTabsResize() {
			this.$nextTick(() => this.updateTabScrollState())
		},
		updateTabScrollState() {
			const container = this.$refs.tabContainer
			if (!container) {
				this.tabsScrollable = false
				this.tabsScrollAtEnd = true
				return
			}
			const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth)
			this.tabsScrollable = maxScrollLeft > 2
			this.tabsScrollAtEnd = maxScrollLeft <= 2 || container.scrollLeft >= maxScrollLeft - 2
		},
		isSuperCouponEnabled() {
			const extraFields = this.gameData && this.gameData.extraFields
			return !!extraFields && extraFields.enableSuperCoupon === true;
		},
		showBankTransfer: function () {
			return this.gameData.gameCode == 'cztxtw' || this.gameData.gameCode == 'sgyjltw';
		},
		loadGoodsList: function () {
			let _this = this;
			axios.get(getGoodsJsonUrl(this.gameData.gameCode))
				.then((response) => {
					_this.goodsData = response.data;
					_this.hasQuota = response.data.hasQuota;
					_this.hasOther = response.data.hasOther;
					_this.hasInGame = response.data.hasInGame;
					// _this.currClassify = _this.hasQuota ? 'quota' : 'direct';
					_this.directGoodsList = response.data.directGoodsList;
					_this.inGameGoodsList = response.data.inGameGoodsList;
					_this.otherGoodsList = response.data.otherGoodsList;
					_this.$nextTick(() => _this.updateTabScrollState())
					if (response.data.hasQuota && _this.hasLogin) {
						_this.initUserQuotaGoodsCount(response.data.quotaGoodsList);
					} else {
						_this.quotaGoodsList = response.data.quotaGoodsList;
					}
				});
		},
		initUserQuotaGoodsCount: function (goodsList) {
			let _this = this;
			this.$axios({
				method: 'get',
				url: '/web/api/payment/getUserQuotaGoodsCount',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.$cache.getGameCode()
				}
			})
				.then(response => {
					if (response.code === 1000) {
						if (response.data.status) {
							goodsList.forEach(function (goods) {
								let dataMap = response.data.goodsQuotaData;
								let array = dataMap[goods.productId];
								if (!isEmpty(array)) {
									goods.quotaNum = array[2];
									goods.limitNum = array[1];
								}
							})
							_this.quotaGoodsList = goodsList;
							_this.hasQuota = true;
						} else {
							_this.hasQuota = false;
						}
						_this.$nextTick(() => _this.updateTabScrollState())
					}
				})
		},
		loadRebateData: function () {
			let _this = this;
			this.$axios({
				method: 'get',
				url: '/web/api/payment/getRebate',
				params: {
					gameCode: this.$cache.getGameCode()
				}
			}).then(response => {
				if (response.code === 1000 && !isEmpty(response.data)) {
					_this.rebate = response.data;
				}
			});
		},
		openGoodsOrder: function (goods) {
			if (!goods) return;
			this.$analytics.track('product_clicked', {
				game_code: this.gameData.gameCode || this.$cache.getGameCode() || null,
				product_id: goods.productId || null,
				product_name: goods.productName || goods.name || null,
				amount: Number.isFinite(Number(goods.amount)) ? Number(goods.amount) : null,
				currency: goods.currency || null,
				product_category: this.currClassify
			});
			if (!this.hasLogin) {
				this.$analytics.track('checkout_blocked', { product_id: goods.productId, reason: 'login_required' });
				this.$refs.header.openLoginWindow();
				return;
			}

			if (isEmpty(this.$cache.getRoleInfo())) {
				this.$analytics.track('checkout_blocked', { product_id: goods.productId, reason: 'role_required' });
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}
			this.goods = goods;
			tracker.productClick(goods.productId);
			this.showOrderWindow = true;
		},
		openConfirmOrderWindow: function (productId) {

			const goodsMap = {
				quota: this.quotaGoodsList,
				direct: this.directGoodsList,
				ingame: this.inGameGoodsList,
				other: this.otherGoodsList
			};

			const goods = goodsMap[this.currClassify]
				.find(el => el.productId === productId);
			this.openGoodsOrder(goods);
		},
		openLimitedCouponOrder: function (goods) {
			this.openGoodsOrder(goods);
		},
		closeOrderWindow: function () {
			this.showOrderWindow = false;
		},
		onCouponSelect: function (coupon) {
			console.log('Coupon selected:', coupon);

			if (coupon) {
				this.selectedCoupon = coupon;
			} else {
				this.selectedCoupon = null;
			}
		},
		async openActivityPopup() {
			if (isEmpty(this.$cache.getRoleInfo())) {
				this.$refs.userInfo.openRoleChooseWindow();
				return;
			}

			this.$nextTick(() => {
				if (this.$refs.CouponLottery) {
					this.$refs.CouponLottery.refreshData();
				}
			});
			console.log(this.gameData.gameCode);

			if (this.gameData.gameCode == 'cztxtw' || this.gameData.gameCode == 'sgyjltw' || this.gameData.gameCode == 'fzsgkr' || this.gameData.gameCode == 'lycqkr') {

				this.showCouponLottery = true;
			} else {
				this.showActivityPopup = true;
			}
		},
		closeCouponLottery() {
			this.showCouponLottery = false;  // 隐藏组件
		},
		openCouponLotteryRules() {
			this.showCouponLottery = true;
			this.$nextTick(() => {
				if (this.$refs.CouponLottery) {
					this.$refs.CouponLottery.refreshData();
					this.$refs.CouponLottery.showRulesPopup = true;
				}
			});
		},
		async openCouponPopup() {
			// if(this.gameData.gameCode === 'lycqkr' && !this.$cache.getLoginData().isTest) return false; // 测试标记，实际使用时请移除
			// if ((this.gameData.gameCode == 'cztxtw' || this.gameData.gameCode == 'sgyjltw' || this.gameData.gameCode == 'lycqkr' || this.gameData.gameCode == 'fzsgkr' || this.gameData.gameCode == 'lycqkr') && this.loginData.isTest === true) {
			// 	this.hasOpenCouponPopup = true
			// 	return true;
			// }

			console.log('Checking coupon popup eligibility for gameCode:', this.gameData.gameCode);
			if (this.gameData.gameCode == 'cztxtw' || this.gameData.gameCode == 'sgyjltw' || this.gameData.gameCode == 'lycqkr' || this.gameData.gameCode == 'fzsgkr' || this.gameData.gameCode == 'lycqkr') {
				const response = await this.$axios({
					method: 'get',
					url: '/web/api/act/getActivity',
					params: {
						gameCode: this.gameData.gameCode,
						activityCode: this.gameData.gameCode + "RebateAct"
					}
				});
				if (response.code === 1000) {
					this.hasOpenCouponPopup = true
					return true;
				} else {
					this.hasOpenCouponPopup = false
					return false;
				}
			}

			const shouldRun = await checkOldActivityEnabled(this.$axios, this.gameData.gameCode);
			if (shouldRun) {
				// if (this.gameData.gameCode == 'cztxkr' || this.gameData.gameCode == 'mym2ru' || this.gameData.gameCode == 'tgru') {

				this.hasOpenCouponPopup = true
				return true;
			}

			this.hasOpenCouponPopup = false;
			return false;
			// return this.gameData.gameCode == 'cztxkr' || this.gameData.gameCode == 'mym2ru';
		},
		changeBackground(newPath) {
			document.documentElement.style.setProperty('--bottom-background-url', `url(${newPath})`);
		},
		changeGoodsTypeEvent: function (classifyName) {
			this.$analytics.track('product_category_selected', { product_category: classifyName });
			if (classifyName === 'transfer' && !this.bankRemitComponent) {
				import('@/components/BankRemit.vue').then(module => {
					this.bankRemitComponent = module.default;
					this.currClassify = classifyName;
				});
			} else {
				this.currClassify = classifyName;
			}
		},
		lookGoodsDetails: function (goods) {
			this.$analytics.track('product_detail_viewed', { product_id: goods.productId, product_name: goods.productName || goods.name || goods.tips });
			this.lookGoods = goods;
			$("#details").bPopup();
		},
		hasRebate: function (goods) {
			let productId = goods.productId;
			if (goods.isRebate === false) {
				return false;
			}
			return isNotEmpty(this.rebate) &&
				(isNotEmpty(this.rebate.config && this.rebate.config[productId]) || this.rebate.rebate !== 0);
		},
		getRebateNum: function (goods) {
			if (this.gameData.gameCode == 'delete') {
				if (!!this.purchasedProducts && this.purchasedProducts.indexOf(goods.productId) > -1) {
					return 10;
				} else {
					return calculateRebatePercent(this.rebate, goods, this.selectedCoupon);
				}
			} else {
				return calculateRebatePercent(this.rebate, goods, this.selectedCoupon);
			}
		},
		async loadPurchasedProducts(productId) {
			this.$axios({
				method: 'get',
				url: '/web/api/payment/getPurchasedProducts',
				params: {
					userId: this.$session.getUserId(),
					gameCode: this.gameData.gameCode
				}
			})
				.then(response => {
					if (response.code == 1000) {
						this.purchasedProducts = response.data;
					}
				});
		},
		async loadComponent() {
			const {
				default: component
			} = await import('@/components/confirmOrder.vue');
			this.dynamicComponent = component;
		}
	}
}
</script>

<style scoped>
.item_Options {
	box-sizing: border-box;
	padding: 0 0 40px;
	background-color: #f4f5f7;
	background-image: none;
}

.recharge-layout {
	position: relative;
	z-index: 100;
	display: grid;
	grid-template-columns: 360px minmax(0, 1fr);
	align-items: start;
	gap: 16px;
	box-sizing: border-box;
	width: calc(100% - 48px);
	max-width: 1280px;
	margin: 0 auto;
}

.recharge-sidebar {
	display: flex;
	min-width: 0;
	flex-direction: column;
	gap: 16px;
}

.recharge-main {
	display: flex;
	min-width: 0;
	flex-direction: column;
	gap: 16px;
}

.recharge-panel {
	box-sizing: border-box;
	width: 100%;
	min-width: 0;
	min-height: 680px;
	margin: 0;
	padding: 16px 16px 24px;
	border: 1px solid #dfe3e8;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0 2px 12px rgba(26, 35, 48, .05);
}

.recharge-panel .product-tabs {
	position: relative;
	margin: -16px -16px 0;
	border-bottom: 1px solid #dfe4ea;
	padding: 0 16px;
	background: #fff;
}

.recharge-panel .tab-container {
	align-items: stretch;
	box-sizing: border-box;
	min-height: 54px;
	gap: 4px;
	padding-right: 32px;
	border-bottom: 0;
	overflow-x: auto;
	overflow-y: hidden;
	overscroll-behavior-x: contain;
	scrollbar-width: none;
}

.recharge-panel .tab-container::-webkit-scrollbar {
	display: none;
}

.recharge-panel .tab-item {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 54px;
	border: 0;
	border-radius: 0;
	padding: 0 14px;
	color: #58616d;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
}

.recharge-panel .tab-item+.tab-item {
	margin-left: 0;
}

.recharge-panel .tab-item::after {
	bottom: 0;
	left: 14px;
	width: calc(100% - 28px);
	height: 2px;
	border-radius: 0;
	background: var(--theme-color, #f26a2e);
}

.recharge-panel .tab-item:hover,
.recharge-panel .tab-item.active {
	color: var(--theme-color, #f26a2e);
}

.recharge-panel .tab-item:hover:not(.active) {
	background: transparent;
}

.recharge-panel .tab-item.active {
	background: transparent;
	font-weight: 700;
}

.recharge-panel .tab-item:focus-visible {
	outline: 2px solid var(--theme-color, #f26a2e);
	outline-offset: -3px;
}

.tab-scroll-hint {
	position: absolute;
	top: 0;
	right: 16px;
	z-index: 2;
	display: flex;
	width: 28px;
	height: 54px;
	align-items: center;
	justify-content: center;
	color: #87909b;
	background: #fff;
	box-shadow: -10px 0 14px rgba(255, 255, 255, .96);
	pointer-events: none;
}

.recharge-panel .describe {
	box-sizing: border-box;
	width: 100%;
	height: 40px;
	margin: 8px 0 0;
	border-radius: 0;
	background: transparent;
	box-shadow: none;
	line-height: 40px;
}

.recharge-panel .describe img {
	width: 24px;
	height: 24px;
	margin: 8px 0 0;
}

.recharge-panel .describe>span {
	margin-left: 10px;
	font-size: 16px;
}

.recharge-panel .describe p {
	min-width: 0;
	margin-left: 10px;
	font-size: 12px;
}

.recharge-panel .describe p span {
	margin-left: 0;
	font-size: 12px;
}

.item_Options .recharge-panel .goods-list {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 16px 12px;
	margin: 12px 0 0;
}

.item_Options .recharge-panel .goods-card {
	box-sizing: border-box;
	width: 100%;
	min-width: 0;
	min-height: 270px;
	margin: 0;
	padding: 12px 10px 10px;
	border: 1px solid #dfe3e8;
	border-radius: 7px;
	background: #fff;
	box-shadow: none;
	transition: transform .18s ease, border-color .18s ease, box-shadow .18s ease;
}

.item_Options .recharge-panel .goods-card:hover,
.item_Options .recharge-panel .goods-card:focus-within {
	z-index: 1;
	border-color: var(--theme-color, #f26a2e);
	box-shadow: 0 7px 18px rgba(33, 40, 50, .1);
	transform: translateY(-3px);
}

.item_Options .recharge-panel .goods-card>.recharge {
	display: block;
	width: min(150px, 90%);
	height: 112px;
	margin: 2px auto 6px;
	object-fit: contain;
	transition: transform .18s ease;
}

.item_Options .recharge-panel .goods-card:hover>.recharge,
.item_Options .recharge-panel .goods-card:focus-within>.recharge {
	transform: scale(1.03);
}

.item_Options .recharge-panel .goods-card>p:not(.goods_index) {
	min-height: 34px;
	padding: 0 4px;
	overflow-wrap: anywhere;
	line-height: 1.5;
}

.item_Options .recharge-panel .goods-card .goods_index {
	min-height: 22px;
	line-height: 22px;
}

.item_Options .recharge-panel .goods-card .points {
	min-height: 24px;
	margin: 4px 0 8px;
	font-size: 16px !important;
}

.item_Options .recharge-panel .goods-card .points img {
	width: 16px;
	height: 16px;
	margin: 0 0 0 6px;
}

.item_Options .recharge-panel .goods-bonus-bar {
	display: inline-flex;
	max-width: 100%;
	min-height: 30px;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	margin: 4px auto 8px;
	border: 1px solid #e0e4e9;
	border-radius: 5px;
	padding: 4px 9px;
	background: #f7f8fa;
}

.item_Options .recharge-panel .goods-bonus-item {
	display: inline-flex;
	min-width: 0;
	align-items: center;
	gap: 5px;
	color: #343a43;
}

.item_Options .recharge-panel .goods-bonus-item + .goods-bonus-item {
	margin-left: 10px;
	border-left: 1px solid #d9dee5;
	padding-left: 10px;
}

.item_Options .recharge-panel .goods-bonus-item img {
	display: block;
	width: 18px;
	height: 18px;
	flex: 0 0 18px;
	object-fit: contain;
}

.item_Options .recharge-panel .goods-bonus-item strong {
	overflow: hidden;
	font-size: 14px;
	font-weight: 800;
	line-height: 20px;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.item_Options .recharge-panel .goods-card button {
	box-sizing: border-box;
	width: 100%;
	height: 38px;
	margin-bottom: 0;
	border-radius: 5px;
	font-size: 13px;
	cursor: pointer;
}

.item_Options .recharge-panel .store {
	top: -4px;
	right: -4px;
	z-index: 2;
	width: 64px;
	height: 67px;
	pointer-events: none;
}

.item_Options .recharge-panel .store img {
	top: 0;
	right: 0;
	left: auto;
	display: block;
	object-fit: contain;
}

.item_Options .recharge-panel .store span {
	top: 0;
	left: 0;
	width: 100%;
	height: auto;
	margin: 11px 0 0;
	font-size: 14px;
	line-height: 1;
	text-align: center;
}

.recharge-panel .h3 {
	margin-top: 28px;
	padding-top: 20px;
	border-top: 1px solid #eceff2;
	font-size: 20px;
}

.recharge-panel .instructions {
	margin: 12px 0 16px;
	color: #727b87;
	font-size: 12px;
	line-height: 1.8;
}

.sidebar-countdown ::v-deep .rcd-pc {
	width: 100%;
	margin: 0;
}

@media (prefers-reduced-motion: reduce) {

	.item_Options .recharge-panel .goods-card,
	.item_Options .recharge-panel .goods-card>.recharge {
		transition: none;
	}

	.item_Options .recharge-panel .goods-card:hover,
	.item_Options .recharge-panel .goods-card:focus-within,
	.item_Options .recharge-panel .goods-card:hover>.recharge,
	.item_Options .recharge-panel .goods-card:focus-within>.recharge {
		transform: none;
	}
}

@media (min-width: 768px) {
	.sidebar-user ::v-deep .content_head {
		box-sizing: border-box;
		width: 100%;
		height: auto;
		min-height: 165px;
		padding: 18px 20px;
		border-left: 4px solid var(--theme-color, #f26a2e);
		border-radius: 8px;
		box-shadow: 0 2px 12px rgba(26, 35, 48, .07);
	}

	.sidebar-user ::v-deep .content_head_left {
		position: relative;
		align-items: center;
		box-sizing: border-box;
		width: 100% !important;
		height: 60px;
		margin: 0;
	}

	.sidebar-user ::v-deep .content_head_left img {
		flex: 0 0 auto;
		width: 48px;
		height: 48px;
		border-radius: 6px;
		object-fit: cover;
	}

	.sidebar-user ::v-deep .content_head_text {
		min-width: 0;
		margin-left: 14px;
	}

	.sidebar-user ::v-deep .content_head_text p {
		overflow: hidden;
		font-size: 18px;
		line-height: 28px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.sidebar-user ::v-deep .content_head_text span {
		display: -webkit-box;
		margin-top: 3px;
		overflow: hidden;
		font-size: 11px;
		line-height: 16px;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}

	.sidebar-user ::v-deep .content_head_right {
		position: relative !important;
		right: auto !important;
		box-sizing: border-box;
		width: 100% !important;
		height: 52px;
		margin: 14px 0 0 !important;
		border: 1px solid #e2e5e8;
		border-radius: 6px;
		background: #f7f8f9;
	}

	.sidebar-user ::v-deep .notLogged {
		font-size: 14px;
		line-height: 52px;
	}

	.sidebar-user ::v-deep .content_head_role {
		align-items: center;
		height: 100%;
		margin: 0 12px;
	}

	.sidebar-user ::v-deep .content_head_role img {
		flex: 0 0 auto;
		width: 36px;
		height: 36px;
	}

	.sidebar-user ::v-deep .Details {
		min-width: 0;
		margin-left: 12px;
	}

	.sidebar-user ::v-deep .Details div {
		height: 20px;
		font-size: 13px;
		line-height: 20px;
	}

	.sidebar-user ::v-deep .Details div p,
	.sidebar-user ::v-deep .Details div p span,
	.sidebar-user ::v-deep .Details>p,
	.sidebar-user ::v-deep .Details>p span {
		font-size: 11px;
		line-height: 16px;
	}
}

@media (min-width: 768px) and (max-width: 1100px) {
	.recharge-layout {
		grid-template-columns: 280px minmax(0, 1fr);
	}

	.item_Options .recharge-panel .goods-list {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
}

@media (max-width: 767px) {
	.item_Options {
		padding-bottom: .6rem;
	}

	.recharge-layout {
		display: block;
		width: 10rem;
		max-width: none;
		margin: 0 auto;
	}

	.recharge-sidebar {
		width: 9.2rem;
		margin: 0 auto;
		gap: .32rem;
	}

	.recharge-main {
		width: 9.2rem;
		margin: .4rem auto 0;
		gap: .32rem;
	}

	.sidebar-countdown ::v-deep .rcd-mobile {
		margin: 0;
	}

	.recharge-panel {
		width: 100%;
		min-height: 0;
		margin: 0;
		padding: .2rem .28rem .4rem;
		border-radius: .18rem;
	}

	.recharge-panel .product-tabs {
		margin: -.2rem -.28rem 0;
		padding: 0 .16rem;
	}

	.recharge-panel .tab-container {
		min-height: 46px;
		padding: 0 .72rem 0 .08rem;
		overflow-x: auto;
		overflow-y: hidden;
		overscroll-behavior-x: contain;
		scroll-behavior: smooth;
		scroll-snap-type: x proximity;
		scrollbar-width: none;
		-webkit-overflow-scrolling: touch;
	}

	.recharge-panel .tab-container::-webkit-scrollbar {
		display: none;
	}

	.recharge-panel .tab-item {
		flex: 0 0 auto;
		min-height: 46px;
		padding: 0 12px;
		font-size: 14px;
		scroll-snap-align: start;
	}

	.recharge-panel .tab-item+.tab-item {
		margin-left: 0;
	}

	.tab-scroll-hint {
		position: absolute;
		top: 0;
		right: .16rem;
		z-index: 2;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 46px;
		color: #9aa1aa;
		font-size: 13px;
		background: #fff;
		box-shadow: -12px 0 16px rgba(255, 255, 255, .96);
		pointer-events: none;
	}

	.recharge-panel .describe {
		height: 1.1rem;
		margin-top: .16rem;
		line-height: 1.1rem;
	}

	.recharge-panel .describe img {
		width: .68rem;
		height: .68rem;
		margin-top: .21rem;
	}

	.recharge-panel .describe p,
	.recharge-panel .describe p span {
		font-size: 12px;
	}

	.item_Options .recharge-panel .goods-list {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: .28rem;
		margin-top: .28rem;
	}

	.item_Options .recharge-panel .goods-card {
		width: 100%;
		min-height: 5.4rem;
		padding: .2rem .18rem .16rem;
		border-radius: .16rem;
	}

	.item_Options .recharge-panel .goods-card>.recharge {
		width: min(3.2rem, 92%);
		height: 2.35rem;
	}

	.item_Options .recharge-panel .goods-card button {
		height: .78rem;
		border-radius: .1rem;
		font-size: 14px;
	}

	.recharge-panel .h3 {
		font-size: 18px;
	}
}
</style>
